import { render, staticRenderFns } from "./AddInvestigator.vue?vue&type=template&id=51597558"
import script from "./AddInvestigator.vue?vue&type=script&lang=js"
export * from "./AddInvestigator.vue?vue&type=script&lang=js"
import style0 from "./AddInvestigator.vue?vue&type=style&index=0&id=51597558&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports